(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-kiosk"] && !Shopify.designMode) return;
  try {
    
(() => {
  const kiosk = document.querySelector('[data-rewards-kiosk]');
  if (!kiosk) return;
  const area = kiosk.querySelector('.rewards-kiosk__form');
  const loading = kiosk.querySelector('.rewards-kiosk__loading');
  let lastActivity = Date.now();
  let successAt = null;
  let resetting = false;
  let root = null;
  let form = null;
  let controls = null;
  let kioskStyle = null;
  const errors = new Map();
  let language = 'en';
  const translations = [
  ["Join Canna Clouds Rewards", "Únete a Canna Clouds Rewards"],
  ["Join Exclusive Smokes Rewards", "Únete a Exclusive Smokes Rewards"],
  [
    "Join Limitless Rewards",
    "Únete a Limitless Rewards"
  ],
  [
    "Sign up to earn rewards.",
    "Regístrate para ganar recompensas."
  ],
  [
    "Full Name",
    "Nombre completo"
  ],
  [
    "Email",
    "Correo electrónico"
  ],
  [
    "Phone number",
    "Número de teléfono"
  ],
  [
    "Rewards terms and email consent",
    "Términos y consentimiento de correo electrónico"
  ],
  [
    "I agree to the Terms and Conditions and to receive email updates and offers. Unsubscribe anytime.",
    "Acepto los Términos y Condiciones y recibir novedades y ofertas por correo electrónico. Puedes cancelar tu suscripción en cualquier momento."
  ],
  [
    "I agree to the",
    "Acepto los"
  ],
  [
    "Terms and Conditions",
    "Términos y Condiciones"
  ],
  [
    "and to receive email updates and offers. Unsubscribe anytime.",
    "y recibir novedades y ofertas por correo electrónico. Puedes cancelar tu suscripción en cualquier momento."
  ],
  [
    "Age confirmation",
    "Confirmación de edad"
  ],
  [
    "I confirm I am 21 or older.",
    "Confirmo que tengo 21 años o más."
  ],
  [
    "JOIN REWARDS",
    "UNIRME A REWARDS"
  ],
  [
    "Please enter your full name.",
    "Ingresa tu nombre y apellido."
  ],
  [
    "Please enter a valid email.",
    "Ingresa un correo electrónico válido."
  ],
  [
    "Please enter a valid phone number.",
    "Ingresa un número de teléfono válido."
  ],
  [
    "Please agree to the Terms and Conditions.",
    "Acepta los Términos y Condiciones."
  ],
  [
    "Please confirm that you are 21 or older.",
    "Confirma que tienes 21 años o más."
  ],
  [
    "✓ YOU’RE ALL SET!",
    "✓ ¡TODO LISTO!"
  ],
  [
    "Your rewards account is ready.",
    "Tu cuenta de recompensas está lista."
  ],
  [
    "Start earning points with today’s purchase.",
    "Empieza a ganar puntos con tu compra de hoy."
  ],
  [
    "Your rewards account is ready. Start earning points with today’s purchase.",
    "Tu cuenta de recompensas está lista. Empieza a ganar puntos con tu compra de hoy."
  ],
  [
    "Loading rewards signup…",
    "Cargando registro de recompensas…"
  ],
  [
    "Signup is temporarily unavailable. Please ask a team member.",
    "El registro no está disponible temporalmente. Pide ayuda a un miembro del equipo."
  ],
  [
    "Please sign out before using this shared rewards kiosk.",
    "Cierra la sesión antes de usar este quiosco compartido de recompensas."
  ],
  [
    "Sign out and reset kiosk",
    "Cerrar sesión y reiniciar el quiosco"
  ],
  [
    "Country code, United States +1",
    "Código de país, Estados Unidos +1"
  ],
  [
    "United States",
    "Estados Unidos"
  ],
  [
    "Search",
    "Buscar"
  ],
  [
    "Submit",
    "Enviar"
  ],
  [
    "Something went wrong. Please try again.",
    "Ocurrió un error. Inténtalo de nuevo."
  ]
];
  const bilingualLookup = new Map(translations.flatMap(pair => pair.map(text => [text, pair])));
  function translated(text) {
    const trimmed = text.trim();
    const pair = bilingualLookup.get(trimmed);
    return pair ? text.replace(trimmed, pair[language === 'es' ? 1 : 0]) : text;
  }
  function localizeTree(scope) {
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      if (node.parentElement?.closest('script,style,textarea,[data-kiosk-language]')) return;
      const next = translated(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    });
    scope.querySelectorAll('[aria-label], [placeholder], img[alt]').forEach(element => {
      ['aria-label','placeholder','alt'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (value === null) return;
        const next = translated(value);
        if (next !== value) element.setAttribute(attribute,next);
      });
    });
  }
  function applyLanguage() {
    document.documentElement.lang = language;
    kiosk.lang = language;
    localizeTree(kiosk);
    if (root) {
      localizeTree(root);
      root.querySelector('[role="dialog"]')?.setAttribute('lang',language);
    }
  }
  kiosk.querySelectorAll('[data-kiosk-language]').forEach(button => {
    button.addEventListener('click', () => {
      language = button.dataset.kioskLanguage;
      kiosk.querySelectorAll('[data-kiosk-language]').forEach(option => option.setAttribute('aria-pressed',String(option === button)));
      activity();
      applyLanguage();
    });
  });


  if (!area) return;

  function erase() {
    kiosk.removeAttribute('data-ready');
    if (root) {
      root.querySelectorAll('input, textarea').forEach(input => {
        input.value = '';
        if ('checked' in input) input.checked = false;
        input.removeAttribute('aria-invalid');
      });
      root.querySelectorAll('[data-kiosk-error]').forEach(node => node.remove());
    }
    errors.clear();
  }
  function reset() {
    if (resetting) return;
    resetting = true;
    erase();
    if (loading) loading.textContent = 'Loading rewards signup…';
    // A fresh document also destroys the embedded form's in-memory state.
    location.replace(location.pathname);
  }
  function activity() { if (!successAt && !resetting) lastActivity = Date.now(); }
  ['pointerdown','touchstart','keydown','input','change','scroll','wheel'].forEach(type => {
    document.addEventListener(type, activity, {capture:true, passive:true});
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && (Date.now() - (successAt || lastActivity) >= (successAt ? 5000 : 60000))) reset();
  });
  window.addEventListener('pagehide', erase);
  window.addEventListener('pageshow', event => { if (event.persisted) reset(); });
  setInterval(() => {
    if (Date.now() - (successAt || lastActivity) >= (successAt ? 5000 : 60000)) reset();
  }, 200);

  function validName(value) {
    const parts = value.trim().replace(/\s+/g, ' ').split(' ');
    const letters = word => (word.match(/\p{L}/gu) || []).length;
    return value.length <= 120 && parts.length >= 2 && letters(parts[0]) >= 2 && letters(parts.at(-1)) >= 2 && parts.every(word => /^(?=.*\p{L})[\p{L}\p{M}’'.-]+$/u.test(word));
  }
  function validPhone(value) {
    const digits = value.replace(/\D/g, '');
    const country = root.querySelector('button[aria-label^="Country code"], button[aria-label^="Código de país"]')?.getAttribute('aria-label') || '';
    if (country.includes('United States +1') || country.includes('Estados Unidos +1')) {
      const national = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
      return /^[2-9]\d{2}[2-9]\d{6}$/.test(national) && !/^(\d)\1{9}$/.test(national);
    }
    // Shopify Forms performs the country-specific validation and E.164 normalization.
    return digits.length >= 7 && digits.length <= 15 && !/^(\d)\1+$/.test(digits);
  }
  function messageFor(key) {
    const input = controls[key];
    if (key === 'name') return validName(input.value) ? '' : 'Please enter your full name.';
    if (key === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim()) ? '' : 'Please enter a valid email.';
    if (key === 'phone') return validPhone(input.value) ? '' : 'Please enter a valid phone number.';
    if (key === 'terms') return input.checked ? '' : 'Please agree to the Terms and Conditions.';
    return input.checked ? '' : 'Please confirm that you are 21 or older.';
  }
  function showError(key, message) {
    const input = controls[key];
    let error = errors.get(key);
    if (!message) {
      error?.remove();
      errors.delete(key);
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      return;
    }
    if (!error) {
      error = document.createElement('p');
      error.dataset.kioskError = key;
      error.id = `kiosk-error-${key}`;
      error.setAttribute('role', 'alert');
      const container = input.closest('fieldset') || input.parentElement;
      container.append(error);
      errors.set(key, error);
    }
    error.textContent = translated(message);
    input.setAttribute('aria-invalid','true');
    input.setAttribute('aria-describedby',error.id);
  }
  function validate(event) {
    let first = null;
    Object.keys(controls).forEach(key => {
      const message = messageFor(key);
      showError(key,message);
      if (message && !first) first = controls[key];
    });
    if (first) {
      event.preventDefault();
      event.stopImmediatePropagation();
      first.focus();
      first.scrollIntoView({block:'center',behavior:'smooth'});
    }
  }
  function prepare() {
    if (!root || resetting) return;
    if (kioskStyle && !root.contains(kioskStyle)) root.append(kioskStyle);
    // This marker is rendered only by Shopify Forms after its successful response.
    const success = ['✓ YOU’RE ALL SET!','✓ ¡TODO LISTO!'].includes(root.querySelector('h2')?.textContent?.trim()) && !root.querySelector('form');
    if (success && !successAt) {
      successAt = Date.now();
      controls = null;
      errors.clear();
      applyLanguage();
      return;
    }
    const nextForm = root.querySelector('form[data-testid="form"]');
    if (!nextForm || nextForm === form) { applyLanguage(); return; }
    const next = {
      name: nextForm.querySelector('#first_name'),
      email: nextForm.querySelector('#email'),
      phone: nextForm.querySelector('#phone_number'),
      terms: nextForm.querySelector('input[type="checkbox"][aria-label*="Terms and Conditions"]'),
      age: nextForm.querySelector('input[type="checkbox"][aria-label*="21 or older"]')
    };
    if (Object.values(next).some(input => !input) || nextForm.querySelectorAll('input[type="checkbox"]').length !== 2) {
      loading.textContent = 'Signup is temporarily unavailable. Please ask a team member.';
      return;
    }
    form = nextForm;
    controls = next;
    controls.terms.dataset.kioskConsent = 'terms';
    controls.age.dataset.kioskConsent = 'age';
    form.autocomplete = 'off';
    form.querySelectorAll('input').forEach(input => {
      input.setAttribute('autocomplete','off');
      input.setAttribute('data-lpignore','true');
      input.setAttribute('data-1p-ignore','true');
      input.setAttribute('aria-required','true');
    });
    controls.name.setAttribute('autocapitalize','words');
    controls.email.setAttribute('autocapitalize','none');
    controls.email.setAttribute('spellcheck','false');
    form.addEventListener('submit',validate,true);
    Object.keys(controls).forEach(key => {
      const input = controls[key];
      input.addEventListener(input.type === 'checkbox' ? 'change' : 'input', () => {
        activity();
        if (errors.has(key)) showError(key,messageFor(key));
      });
    });
    const termsLegend = controls.terms.closest('fieldset')?.querySelector('legend');
    if (termsLegend) termsLegend.textContent = 'Rewards terms and email consent';
    const consentText = controls.terms.closest('label')?.querySelector('span');
    if (consentText && kiosk.dataset.terms) {
      const text = consentText.textContent;
      const phrase = 'Terms and Conditions';
      const index = text.indexOf(phrase);
      if (index >= 0) {
        const link = document.createElement('a');
        link.href = kiosk.dataset.terms;
        link.textContent = phrase;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.addEventListener('click',event => event.stopPropagation());
        consentText.replaceChildren(document.createTextNode(text.slice(0,index)),link,document.createTextNode(text.slice(index + phrase.length)));
      }
    }
    area.removeAttribute('aria-busy');
    kiosk.setAttribute('data-ready','');
    lastActivity = Date.now();
    applyLanguage();
  }
  function attach() {
    if (root || resetting) return;
    const embed = area.querySelector('shopify-forms-embed');
    if (!embed?.shadowRoot) return;
    root = embed.shadowRoot;
    const css = document.createElement('style');
    kioskStyle = css;
    css.dataset.kioskStyle = 'true';
    css.textContent = `
      :host { --inline-container-max-width:100%!important; --forms-base-font-size:17px!important; --forms-heading-font-size:32px!important; --forms-padding-top:0px!important; --forms-padding-bottom:0px!important; --form-field-border-radius:10px!important; --button-border-radius:12px!important; }
      [role="dialog"] { padding:0!important; background:transparent!important; }
      *, *::before, *::after { box-sizing:border-box!important; }
      h2 { margin:0 0 8px!important; font-size:clamp(28px,4vw,38px)!important; line-height:1.08!important; text-transform:uppercase!important; font-weight:750!important; }
      #app-embed [class*="_textBody"] { font-size:17px!important; line-height:1.45!important; }
      form { gap:16px!important; }
      form > div:has(#first_name) { order:1; }
      form > div:has(#email) { order:2; }
      form > div:has(#phone_number) { order:3; }
      fieldset:has(input[data-kiosk-consent="terms"]) { order:4; }
      fieldset:has(input[data-kiosk-consent="age"]) { order:5; }
      form > button { order:6!important; }
      input:not([type="checkbox"]) { min-height:60px!important; font-size:19px!important; }
      label[for="first_name"], label[for="email"], label[for="phone_number"] { font-size:16px!important; }
      input[type="checkbox"] { width:26px!important; height:26px!important; min-width:26px!important; cursor:pointer; margin:0!important; }
      [class*="_checkboxWrapper"] { width:26px!important; height:26px!important; min-width:26px!important; }
      fieldset { margin:0!important; border:0!important; }
      legend { font-size:14px!important; font-weight:700!important; margin-bottom:5px!important; }
      label:has(input[type="checkbox"]) { display:grid!important; grid-template-columns:26px minmax(0,1fr)!important; min-height:46px; align-items:flex-start!important; gap:12px!important; font-size:16px!important; line-height:1.45!important; cursor:pointer; }
      form > button { min-height:62px!important; font-size:20px!important; font-weight:750!important; letter-spacing:.045em; }
      [data-kiosk-error] { color:#B42318; font:600 14px/1.4 Arial,sans-serif; margin:7px 0 0; text-align:left; }
      input[aria-invalid="true"] { outline:2px solid #B42318!important; outline-offset:2px; }
      a { text-underline-offset:3px; }
      @media(max-height:750px) and (min-width:760px) { h2{font-size:29px!important;} form{gap:11px!important;} input:not([type="checkbox"]){min-height:54px!important;} }
    `;
    root.append(css);
    new MutationObserver(prepare).observe(root,{childList:true,subtree:true});
    prepare();
  }
  new MutationObserver(attach).observe(area,{childList:true,subtree:true});
  const discovery = setInterval(() => { attach(); if (root) clearInterval(discovery); },150);
  attach();
})();

  } catch(e) { console.error(e); }
})();
})();
